import React, { useEffect } from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';
import { FAQ } from '@/constants/testIds';

const faqs = [
  {
    q: 'Do you ship Indian clothes across the USA?',
    a: 'Yes — we ship pan-USA. Local customers in Morrisville, Cary, Raleigh, Durham and Apex can pick up in-store. Customers elsewhere in the US can WhatsApp us on 984-377-9835 and we\'ll walk you through sizing and shipping.',
  },
  {
    q: 'Can I visit your boutique in Morrisville, NC?',
    a: 'Absolutely — the showroom is at 158 Liberty Rose Dr, Morrisville, NC 27560. Open daily 4:30 PM – 8:30 PM. Please call or text 984-377-9835 to plan a private appointment.',
  },
  {
    q: 'How do I choose the right size for online orders?',
    a: 'Most pieces are available XS – XXL, with custom sizing on request up to XXXL. Send us your bust / waist / hip measurements on WhatsApp — we\'ll recommend the best fit and tailor the outfit before shipping if needed.',
  },
  {
    q: 'What outfits are best for Indian weddings?',
    a: 'For the bride, hand-embroidered lehengas or heavy Banarasi sarees. For guests, cocktail lehengas, sequin sarees or Anarkali suits. Sangeet & mehendi lean lighter — organza sarees, sharara sets or gowns work beautifully.',
  },
  {
    q: 'Do you dress kids and men too?',
    a: 'Yes — we carry kids ethnic wear, men\'s kurta-pajama, sherwanis and Indo-western sets so the whole family can be styled for weddings and festivals.',
  },
];

const FAQ_JSONLD_ID = 'home-faq-jsonld';

export const FAQSection = () => {
  // Inject FAQPage structured data (independent of useSEO route hook)
  useEffect(() => {
    const prev = document.head.querySelector(`script[data-key="${FAQ_JSONLD_ID}"]`);
    if (prev) prev.remove();
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.setAttribute('data-key', FAQ_JSONLD_ID);
    script.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: faqs.map((f) => ({
        '@type': 'Question',
        name: f.q,
        acceptedAnswer: { '@type': 'Answer', text: f.a },
      })),
    });
    document.head.appendChild(script);
    return () => {
      const el = document.head.querySelector(`script[data-key="${FAQ_JSONLD_ID}"]`);
      if (el) el.remove();
    };
  }, []);

  return (
    <section data-testid={FAQ.root} className="py-24 lg:py-32 bg-surface">
      <div className="container-luxe max-w-4xl">
        <div className="text-center mb-12">
          <span className="overline">Questions</span>
          <h2 className="font-display text-4xl lg:text-5xl text-charcoal mt-3 leading-tight">
            Quick <em className="text-maroon not-italic font-medium">answers</em>.
          </h2>
          <div className="mt-5 mx-auto h-px w-16 bg-gold" />
        </div>

        <Accordion type="single" collapsible className="w-full">
          {faqs.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} data-testid={FAQ.item(i)} className="border-brandborder">
              <AccordionTrigger className="font-display text-lg md:text-xl text-charcoal hover:text-maroon text-left py-6">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-charcoal/75 leading-relaxed pb-6">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQSection;
